import {
  CloseButtonStyle,
  ModalDescriptionStyle,
  ModalHeaderStyle,
  ModalTitleStyle,
} from '../ContractIdSelectionModal.style';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
interface ModalHeaderProps {
  onClose: () => void;
  isEditMode?: boolean;
}

export function ModalHeader({ onClose, isEditMode = false }: ModalHeaderProps) {
  return (
    <ModalHeaderStyle>
      <div>
        <ModalTitleStyle>Select Contract IDs</ModalTitleStyle>
        <ModalDescriptionStyle>
          {isEditMode
            ? 'Select one or more Contract IDs.'
            : 'Select one or more Contract IDs. The combined Tax ID count cannot exceed 1,000. Contract IDs that exceed the remaining limit will be disabled.'}
        </ModalDescriptionStyle>
      </div>
      <CloseButtonStyle type="button" aria-label="Close" onClick={onClose}>
        <IconSymbol icon="close" color="#000000" />
      </CloseButtonStyle>
    </ModalHeaderStyle>
  );
}
